import script from "./Grades.vue?vue&type=script&setup=true&lang=js"
export * from "./Grades.vue?vue&type=script&setup=true&lang=js"

import "./Grades.vue?vue&type=style&index=0&id=1233b1c6&lang=css"

const __exports__ = script;

export default __exports__